import styled from "styled-components";
import { Steps, Layout } from "antd";

const { Step } = Steps;
const { Content } = Layout;

export const PageContent = styled(Content)`
  min-height: 100%;
  width: fit-content;
  margin-top: 64px;
  background-color: #1070b6;
  padding: 30px 5%;

  @media (min-width: 750px) {
    width: 100%;
  }
`;

export const FormCard = styled.div`
  background: white;
  padding: 15px 20px 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  max-width: 510px;
  margin-top: 32px;
  border-radius: 2px;
`;

export const CardTitle = styled.div`
  font-weight: bold;
  color: #1070b6;
  text-align: left;
  font-size: 34px;
  transform: scaleY(1.07);
`;

export const FormInfo = styled.div`
  font-size: 16px;
  color: #707070;
  text-align: left;
  margin-bottom: 10px;
`;

export const CustomSteps = styled(Steps)`
  margin-right: 0px;
  width: 100%;
  flex-direction: row !important;
  /* justify-content: space-between; */

  & .ant-steps-item-tail::after {
    height: 0px;
  }

  & .ant-steps-item-title {
    color: white !important;
    font-weight: bold;
  }

  & .ant-steps-item-process .ant-steps-item-icon .ant-steps-icon {
    color: #1070b6;
  }

  @media (max-width: 480px) {
    &.ant-steps-horizontal.ant-steps-label-horizontal .ant-steps-item-content {
      min-height: 0px;
    }

    &.ant-steps-horizontal.ant-steps-label-horizontal
      > .ant-steps-item
      > .ant-steps-item-container
      > .ant-steps-item-tail::after {
      height: 0px;
    }
  }
`;

export const CustomStep = styled(Step)`
  width: 30%;

  & .ant-steps-item-icon .ant-steps-icon {
    font-weight: bold;
  }

  &.ant-steps-item-process .ant-steps-item-icon {
    background: white;
    border: 2px solid white;
  }

  & .ant-steps-item-active > .ant-steps-item-icon {
    color: #1070b6;
    background-color: white;
  }

  & .ant-steps-item-icon {
    margin-right: 10px !important;
  }

  & .ant-steps-horizontal.ant-steps-label-horizontal .ant-steps-item-content {
    margin-right: 0px;
  }

  &.ant-steps-item-finish
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title::after {
    background-color: white;
  }
  &.ant-steps-item-wait
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title::after,
  &.ant-steps-item-process
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title::after {
    display: none;
  }
`;

export const LinkedText = styled.a`
  color: #1070b6;
  font-weight: bold;
`;
